export default __webpack_public_path__ + "static/media/Christmas_31.ee157bda.png";